module.exports = __webpack_public_path__ + "img/41.737c5687.jpg";